import GET_PAGES from "./getPages";
import SET_PAGES from "./setPages";

export default {
  GET_PAGES,
  SET_PAGES
};
